import { faPause, faPlay, faSpinner, faStop } from "@fortawesome/free-solid-svg-icons";
import { Div, Field, Label, Progress, Section } from "trunx";
import { LeafletPanelBody, LeafletPanelHeading } from "../shared/LeafletPanel";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect } from "react";
import { useLocaleContext } from "../contexts/LocaleContext";
import RadarContext from "../contexts/RadarContext";
import { useRootStore } from "../models/Root";

const RadarPanel = () => {
  const {
    lang,
    dict: {
      panel: { radar: dict },
    },
  } = useLocaleContext();

  const radar = useContext(RadarContext);

  const {
    menus: { closePanel },
  } = useRootStore();

  // Auto-start loading when panel opens
  useEffect(() => {
    if (radar?.times && !radar.visible) {
      radar.setVisible(true);
    }
  }, [radar]);

  if (!radar?.times) {
    return (
      <Div bulma="panel">
        <Section>
          <LeafletPanelHeading title={dict.title} close={closePanel} />
        </Section>
        <div className="radar is-loading">&nbsp;</div>
      </Div>
    );
  }

  const {
    frame,
    setVisible,
    playing,
    setPlaying,
    speed,
    setSpeed,
    opacity,
    setOpacity,
    framesLoaded,
    framesTotal,
  } = radar;
  const { times } = radar;
  const frameTime = times![frame];
  const isLoading = framesLoaded < framesTotal;

  const stop = () => {
    setPlaying(false);
    setVisible(false);
  };

  const playPause = () => {
    setPlaying(!playing);
    setVisible(true);
  };

  return (
    <Div bulma="panel">
      <Div bulma="panel-heading">
        <LeafletPanelHeading title={dict.title} close={closePanel} />
      </Div>
      <LeafletPanelBody>
        <Section>
          <Div bulma={["level", "is-mobile"]}>
            <Div bulma="level-left">
              <Div bulma={["level-item"]}>
                {isLoading ? (
                  <Div bulma="level-item" style={{ fontSize: "0.85em" }}>
                    <FontAwesomeIcon icon={faSpinner} spin />
                    &nbsp;
                    {framesLoaded}/{framesTotal}
                  </Div>
                ) : (
                  <>
                    <Div bulma="level-item" onClick={() => playPause()}>
                      <FontAwesomeIcon icon={playing ? faPause : faPlay} />
                    </Div>
                    &nbsp;
                    <Div bulma="level-item" onClick={() => stop()}>
                      <FontAwesomeIcon icon={faStop} />
                    </Div>
                  </>
                )}
              </Div>
            </Div>
            <Div bulma="level-item">
              {isLoading ? (
                <Progress bulma="is-info" value={framesLoaded} max={framesTotal} />
              ) : (
                <Progress value={framesTotal - frame} max={framesTotal} />
              )}
            </Div>
            {!isLoading && (
              <Div bulma="level-right">
                <Div bulma={["level-item", "ml-2"]}>
                  {frameTime?.toLocaleTimeString(lang)}
                </Div>
              </Div>
            )}
          </Div>

          <Field bulma="is-horizontal">
            <Div bulma="field-label">
              <Label>{dict.opacity}</Label>
            </Div>
            <div className="field-body">
              <div className="field">
                <div className="control">
                  <input
                    style={{ width: "80%" }}
                    step="1"
                    min="1"
                    max="100"
                    type="range"
                    value={opacity * 100}
                    onChange={({ target }) =>
                      setOpacity(parseInt(target.value) / 100)
                    }
                  ></input>
                </div>
              </div>
            </div>
          </Field>

          <Field bulma="is-horizontal">
            <Div bulma="field-label">
              <Label>{dict.speed}</Label>
            </Div>
            <div className="field-body">
              <div className="field">
                <div className="control">
                  <input
                    style={{ width: "80%" }}
                    step="100"
                    min="0"
                    max="1000"
                    type="range"
                    value={speed}
                    onChange={({ target }) => setSpeed(parseInt(target.value))}
                  ></input>
                </div>
              </div>
            </div>
          </Field>
        </Section>
      </LeafletPanelBody>
    </Div>
  );
};
export default RadarPanel;
